/** Centralized legal compliance configuration and helpers */

import { BRANDING, LEGAL, DATABASE, isAdminSchema } from '@webready/shared/config';

export const WEBREADY_SCHEMA = DATABASE.adminSchema;

export const isWebReadyTenant = (): boolean =>
  isAdminSchema(import.meta.env.VITE_DB_SCHEMA || '');

export const WEBREADY_OPERATOR = LEGAL.operator;

export const WEBREADY_LEGAL_ROUTES = LEGAL.routes;

export const WEBREADY_EXTERNAL_LINKS = LEGAL.externalLinks;

export const WEBREADY_LITIGII_IMAGES = LEGAL.litigiiImages;

export const WEBREADY_WHATSAPP_GDPR_MESSAGE = `Bună! Prin continuarea conversației pe WhatsApp, confirmați că datele dvs. (inclusiv numărul de telefon) pot fi prelucrate de ${LEGAL.operator.shortName} în scopul ofertării comerciale ${BRANDING.appName}, conform Politicii de Confidențialitate: https://${BRANDING.domain}${LEGAL.routes.privacy}`;
